import {
  BuilderLayer,
  KeplerLayer,
  KeplerLayerConfig,
  KeplerStoredVisualChannel,
  KeplerTableField
} from 'features/builder/types'
import { shallowEqual } from 'react-redux'

export function serializeKeplerLayer(layer: KeplerLayer): BuilderLayer {
  const config: Partial<KeplerLayerConfig> = { ...layer.config }
  delete config.colorUI
  config.textLabel = config.textLabel?.map((label) => ({
    ...label,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    field: label.field ? ({ name: label.field.name, type: label.field.type } as any) : null
  }))
  const visualChannels: Record<string, KeplerStoredVisualChannel> = {}
  Object.values(layer.visualChannels || {}).forEach((channel) => {
    const fieldName = channel.field
    const field = config[fieldName] as KeplerTableField
    if (config[fieldName]) {
      visualChannels[fieldName] = {
        name: field.id,
        type: field.type,
        ...(field.colorColumn && { colorColumn: field.colorColumn })
      }
      delete config[fieldName]
    }
    const scaleName = channel.scale
    if (config[scaleName]) {
      const scale = config[scaleName]
      visualChannels[scaleName] = scale
      delete config[scaleName]
    }
    const domain = channel.domain
    if (config[domain]) {
      delete config[domain]
    }
  })
  const persistedLayer: BuilderLayer = {
    id: layer.id,
    type: layer.type,
    config: config as KeplerLayerConfig,
    visualChannels
  }
  return persistedLayer
}

const createSerializedKeplerLayerMemoized = () => {
  const entries = new Map<string, { keyProps: unknown[]; result }>()
  return (layer: KeplerLayer) => {
    const previous = entries.get(layer.id)
    const keyProps = [layer.type, layer.config]
    if (previous && shallowEqual(previous.keyProps, keyProps)) {
      return previous.result
    }
    const result = serializeKeplerLayer(layer)
    entries.set(layer.id, { keyProps: keyProps, result })
    return result
  }
}

export const serializedKeplerLayerMemoized = createSerializedKeplerLayerMemoized()
